<div class="icon-wrapper">
    <span class="ham-icon"> <i class="link-icon"></i> </span>
</div>
<div class="sso-redirect-page">
    <h1 *ngIf="hasError || loading">Single Sign On</h1>
    <h1 *ngIf="!hasError && !loading">{{ssoProvider.title}}</h1>
    <p *ngIf="!hasError && !loading">{{ssoProvider.message}}.</p>
    <p *ngIf="hasError">{{error}}</p>
    <div class="button-wrapper">
        <ham-button variant="white" [routerLink]="['../../login']">
            {{'aumico_confirmation_modal_cancel_button' | i18next}}
        </ham-button>
        <!-- Popup‐flow button -->

        <ham-button
            *ngIf="!hasError && !loading && usePopupLoginSAML"
            (buttonClick)="onLoginWithPopupSAML()"
            type="submit"
        >
            {{'aumico_reports_login_login_button' | i18next}}
        </ham-button>
        <ham-button
            *ngIf="!hasError && !loading && usePopupLoginOIDC"
            (buttonClick)="onLoginWithPopupOIDC()"
            type="submit"
        >
            {{'aumico_reports_login_login_button' | i18next}}
        </ham-button>
        <ham-button
            *ngIf="!hasError && !loading && useRedirectLoginOIDC"
            (buttonClick)="onLoginRedirectClick()"
            type="submit"
        >
            {{'aumico_reports_login_login_button' | i18next}}
        </ham-button>
    </div>
</div>
